import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const PersonIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Overrides/Icons/Profile" stroke={color} strokeWidth="2">
          <g id="Group" transform="translate(1.000000, 1.000000)">
            <path
              d="M0,11 C0,14.9299215 2.09658808,18.5613187 5.5,20.5262794 C8.90341182,22.4912402 13.0965882,22.4912402 16.5,20.5262794 C19.9034119,18.5613187 22,14.9299215 22,11 C22,7.07007853 19.9034119,3.43868132 16.5,1.47372056 C13.0965882,-0.491240188 8.90341182,-0.491240188 5.5,1.47372056 C2.09658808,3.43868132 0,7.07007853 0,11 L0,11 Z"
              id="Path"
            ></path>
            <path
              d="M3.3086087,18.8635651 C4.94194977,17.9164727 6.6793861,17.1615401 8.48626087,16.613826 C9.28686957,16.3182608 9.37391304,14.4817391 8.8,13.8504347 C7.97165217,12.9388695 7.26956522,11.8704348 7.26956522,9.2916522 C7.17196572,8.25242752 7.52442028,7.22120374 8.23767743,6.45911592 C8.95093458,5.6970281 9.95659609,5.27715711 11,5.30582617 C12.0434039,5.27715711 13.0490654,5.6970281 13.7623226,6.45911592 C14.4755797,7.22120374 14.8280343,8.25242752 14.7304348,9.2916522 C14.7304348,11.8742609 14.0283478,12.9388695 13.2,13.8504347 C12.626087,14.4817391 12.7131304,16.3182608 13.5137391,16.613826 C15.3206139,17.1615401 17.0580502,17.9164727 18.6913913,18.8635651"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
